class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
    this.setupCategorySubmit();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));

    this.input.addEventListener('focus', this.onInputFocus.bind(this));

    if (allSearchForms.length < 2) return;

    allSearchForms.forEach((form) =>
      form.addEventListener('reset', this.onFormReset.bind(this))
    );

    this.allSearchInputs.forEach((input) =>
      input.addEventListener('input', this.onInput.bind(this))
    );
  }

  setupCategorySubmit() {
    const form = this.querySelector('form');
    const select = this.querySelector('#MainSearchFilter');
    const input = this.querySelector('input[name="q"]');

    if (!form || !input) return;

    if (select) {
      const params = new URLSearchParams(window.location.search);
      const urlCategory = params.get('category');
      if (urlCategory) {
        for (const option of select.options) {
          if (option.value.toLowerCase() === urlCategory.toLowerCase()) {
            select.value = option.value;
            break;
          }
        }
      }
    }

    form.addEventListener('submit', (e) => {
      const query = input.value.trim();
      if (!query) {
        e.preventDefault();
        return;
      }

      if (!select) return;

      e.preventDefault();

      const url = this.isAllCategories(select.value)
        ? this.buildAllCategoriesSearchUrl(query)
        : this.buildCategorySearchUrl(query, select.value);

      window.location.href = url;
    });
  }

  isAllCategories(category) {
    const normalized = category?.trim().toLowerCase();
    return !normalized || normalized === 'all categories';
  }

  buildPredictiveQuery(query, category) {
    const trimmedQuery = query.trim();
    if (this.isAllCategories(category)) return trimmedQuery;
    return `${trimmedQuery} ${category.trim().toLowerCase()}`;
  }

  buildCategorySearchUrl(query, category) {
    const trimmedQuery = query.trim();
    const trimmedCategory = category?.trim() || '';
    const predictiveQuery = this.buildPredictiveQuery(trimmedQuery, trimmedCategory);

    const params = new URLSearchParams();
    params.set('q', predictiveQuery);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('view_q', trimmedQuery);
    params.set('category', trimmedCategory);

    return `/search?${params.toString()}`;
  }

  buildAllCategoriesSearchUrl(query) {
    const params = new URLSearchParams();
    params.set('q', query.trim());
    params.set('type', 'product');
    return `/search?${params.toString()}`;
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    if (window.innerWidth < 750) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

function isAllCategories(category) {
  const normalized = category?.trim().toLowerCase();
  return !normalized || normalized === 'all categories';
}

function buildPredictiveQuery(query, category) {
  const trimmedQuery = query.trim();
  if (isAllCategories(category)) return trimmedQuery;
  return `${trimmedQuery} ${category.trim().toLowerCase()}`;
}

function patchFacetSearchQuery(query) {
  if (!query) return;

  document
    .querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm')
    .forEach((form) => {
      let qInput = form.querySelector('input[name="q"]');
      if (!qInput) {
        qInput = document.createElement('input');
        qInput.type = 'hidden';
        qInput.name = 'q';
        form.prepend(qInput);
      }
      qInput.value = query;

      if (!form.querySelector('input[name="type"]')) {
        const typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'type';
        typeInput.value = 'product';
        form.appendChild(typeInput);
      }

      form.querySelector('input[name="options[prefix]"]')?.remove();
    });
}

function patchFacetFilterLinks(query) {
  if (!query) return;

  const searchPath = window.location.pathname;

  document
    .querySelectorAll(
      '#main-search-filters a[href*="filter"], #main-search-filters .active-facets a, facet-remove a'
    )
    .forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        const params = new URLSearchParams(url.search);
        params.set('q', query);
        params.set('type', 'product');
        params.delete('page');
        link.href = `${searchPath}?${params.toString()}`;
      } catch {
        
      }
    });
}

function findFiltersAside(doc) {
  const direct =
    doc.querySelector('#main-search-filters') || doc.querySelector('#main-collection-filters');
  if (direct) return direct;

  for (const wrapper of doc.querySelectorAll('.facets-wrapper')) {
    if (wrapper.querySelector('.js-filter')) return wrapper;
  }

  return null;
}

function injectFetchedFacets(bootstrap, doc, query, mainSectionId) {
  const filtersAside = findFiltersAside(doc);
  if (!filtersAside?.querySelector('.js-filter')) return false;

  const importedAside = document.importNode(filtersAside, true);
  if (importedAside.id === 'main-collection-filters') {
    importedAside.id = 'main-search-filters';
  }
  importedAside.dataset.id = mainSectionId;
  bootstrap.replaceWith(importedAside);
  patchFacetSearchQuery(query);
  patchFacetFilterLinks(query);

  const sortBootstrap = document.getElementById('main-search-sort-bootstrap');
  const fetchedSort = doc.querySelector('.facets-vertical-sort');

  const prepareSortBar = (sortNode) => {
    sortNode.querySelector('#ProductCountDesktop')?.replaceChildren();
    return sortNode;
  };

  if (sortBootstrap && fetchedSort) {
    sortBootstrap.replaceWith(prepareSortBar(document.importNode(fetchedSort, true)));
    patchFacetSearchQuery(query);
  } else if (!document.querySelector('.facets-vertical-sort') && fetchedSort) {
    const facetsVertical = document.querySelector('.template-search .facets-vertical');
    facetsVertical?.parentElement?.insertBefore(
      prepareSortBar(document.importNode(fetchedSort, true)),
      facetsVertical
    );
    patchFacetSearchQuery(query);
  }

  patchFacetFilterLinks(query);
  return true;
}

async function loadMainSearchFacetsBootstrap() {
  const bootstrap = document.getElementById('main-search-facets-bootstrap');
  if (!bootstrap) return false;

  const mainSectionId = bootstrap.dataset.sectionId;
  const facetsSectionId = bootstrap.dataset.facetsSectionId || 'main-search-facets';
  const facetsBasePath = bootstrap.dataset.facetsUrl || '/collections/all';
  const query = bootstrap.dataset.query?.trim() || '';

  const fetchAttempts = [
    { basePath: facetsBasePath, sectionId: facetsSectionId, params: '' },
    { basePath: facetsBasePath, sectionId: 'main-collection-product-grid', params: '' },
    { basePath: window.location.pathname, sectionId: facetsSectionId, params: 'type=product' },
    { basePath: window.location.pathname, sectionId: mainSectionId, params: 'type=product' },
    {
      basePath: window.location.pathname,
      sectionId: mainSectionId,
      params: `type=product&q=${encodeURIComponent(query)}&options%5Bprefix%5D=last`,
    },
  ];

  for (const { basePath, sectionId, params } of fetchAttempts) {
    const url = params
      ? `${basePath}?section_id=${sectionId}&${params}`
      : `${basePath}?section_id=${sectionId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) continue;

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (injectFetchedFacets(bootstrap, doc, query, mainSectionId)) return true;
    } catch {
      continue;
    }
  }

  bootstrap.querySelector('.loading-overlay')?.classList.add('hidden');
  return false;
}

function updateMainSearchProductCount(count) {
  const container = document.getElementById('main-search-predictive-container');
  const template = container?.dataset.countTemplate;
  const text = template
    ? template.replace('__COUNT__', String(count))
    : `${count} product${count === 1 ? '' : 's'}`;

  ['ProductCountDesktop', 'ProductCount'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.textContent = text;
  });

  updateMainSearchBreadcrumb(count);
}

function updateMainSearchBreadcrumb(count) {
  const container = document.getElementById('main-search-predictive-container');
  const breadcrumbCount = document.getElementById('search-breadcrumb-count');
  if (!container || !breadcrumbCount) return;

  const template =
    count === 1 ? container.dataset.breadcrumbOne : container.dataset.breadcrumbOther;
  if (!template) return;

  breadcrumbCount.textContent = template.replace(/\d+/, String(count));
}

function loadMainSearchPredictiveProducts() {
  const container = document.getElementById('main-search-predictive-container');
  if (!container || typeof routes === 'undefined' || !routes.predictive_search_url) return;

  const viewQuery = container.dataset.query?.trim();
  const category = container.dataset.category || '';
  const sectionId = container.dataset.sectionId || 'main-search-products';
  if (!viewQuery) return;

  const predictiveQuery = buildPredictiveQuery(viewQuery, category);
  const url = `${routes.predictive_search_url}?q=${encodeURIComponent(predictiveQuery)}&resources[type]=product&section_id=${sectionId}`;

  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.text();
    })
    .then((text) => {
      const section = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector(`#shopify-section-${sectionId}`);

      if (!section) return;

      container.innerHTML = section.innerHTML;

      const productGrid = document.getElementById('product-grid');
      productGrid?.querySelector('.loading-overlay')?.classList.add('hidden');

      const productItems = container.querySelectorAll('#main-search-products-list .grid__item');
      const productCount = productItems.length;
      updateMainSearchProductCount(productCount);

      const hasProducts = productCount > 0;
      const noResults = document.getElementById('main-search-no-results');
      const templateSearch = document.querySelector('.template-search');

      if (hasProducts) {
        if (noResults) noResults.hidden = true;
        templateSearch?.classList.remove('template-search--empty');
      } else if (noResults) {
        noResults.hidden = false;
      }
    })
    .catch(() => {
      const productGrid = document.getElementById('product-grid');
      productGrid?.querySelector('.loading-overlay')?.classList.add('hidden');
      updateMainSearchProductCount(0);
      const noResults = document.getElementById('main-search-no-results');
      if (noResults) noResults.hidden = false;
    });
}

document.addEventListener('DOMContentLoaded', async () => {
  const params = new URLSearchParams(window.location.search);
  const viewQ = params.get('view_q');

  if (viewQ) {
    document.querySelectorAll('input[type="search"][name="q"]').forEach((input) => {
      input.value = viewQ;
    });
  }

  await loadMainSearchFacetsBootstrap();
  loadMainSearchPredictiveProducts();
});
